module.exports = new __parcel__URL__("load_text_4.1ad322b3.png").toString();